import { render, staticRenderFns } from "./work-bids-list.vue?vue&type=template&id=487f1e64&scoped=true&"
import script from "./work-bids-list.vue?vue&type=script&lang=js&"
export * from "./work-bids-list.vue?vue&type=script&lang=js&"
import style0 from "./work-bids-list.vue?vue&type=style&index=0&id=487f1e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f1e64",
  null
  
)

export default component.exports